(() => {
  if (window.PhoneShopAccessories) { window.PhoneShopAccessories.init(document); return; }
  const controllers = new WeakMap();
  const init = (scope = document) => {
    const sections = [...(scope.matches?.('[data-ps-accessories]') ? [scope] : []), ...scope.querySelectorAll('[data-ps-accessories]')];
    sections.forEach(section => {
      if (controllers.has(section)) return;
      const abort = new AbortController();
      const formatter = new Intl.NumberFormat(section.dataset.locale || 'en-NZ', { style: 'currency', currency: section.dataset.currency || 'NZD' });
      const rootURL = (window.psConfig?.root || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      let text = {};
      try { text = JSON.parse(section.querySelector('[data-ps-accessories-translations]')?.textContent || '{}'); } catch {}
      section.addEventListener('change', event => {
        const select = event.target.closest('[data-ps-accessory-variant]');
        if (!select) return;
        const card = select.closest('[data-ps-accessory]');
        const option = select.selectedOptions[0];
        if (!card || !option || option.disabled) return;
        select.querySelector('[data-ps-accessory-prompt]')?.remove();
        const form = select.closest('form');
        if (form) { form.dataset.psAvailable = 'true'; const button = form.querySelector('[type="submit"]'); if (button && !form.dataset.busy) button.disabled = false; }
        const price = card.querySelector('[data-ps-accessory-price]');
        if (price && Number.isFinite(Number(option.dataset.price))) price.textContent = formatter.format(Number(option.dataset.price) / 100);
        card.querySelectorAll('[data-ps-accessory-link]').forEach(link => { if (option.dataset.url) link.href = option.dataset.url; });
        const media = card.querySelector('.ps-accessory__image');
        const placeholder = media?.querySelector('[data-ps-accessory-placeholder]');
        let image = media?.querySelector('img');
        if (option.dataset.image && media) {
          if (!image) { image = document.createElement('img'); image.width = 240; image.height = 240; image.alt = media.getAttribute('aria-label') || ''; image.loading = 'lazy'; media.prepend(image); }
          image.hidden = false;
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
          if (placeholder) placeholder.hidden = true;
        } else {
          if (image) image.hidden = true;
          if (placeholder) placeholder.hidden = false;
        }
        const status = card.querySelector('[data-ps-form-status]');
        if (status) status.textContent = '';
      }, { signal: abort.signal });
      section.addEventListener('ps:cart-error', async event => {
        const card = event.target.closest('[data-ps-accessory]');
        const form = event.target.closest('form');
        if (!card || !form || card.dataset.refreshingStock || !card.dataset.productHandle) return;
        card.dataset.refreshingStock = 'true';
        try {
          const response = await fetch(rootURL + 'products/' + encodeURIComponent(card.dataset.productHandle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: abort.signal });
          if (!response.ok && response.status !== 404) return;
          const fresh = response.status === 404 ? {available: false, variants: []} : await response.json();
          if (!Array.isArray(fresh.variants)) return;
          const available = fresh.variants.filter(variant => variant.available);
          const availableIDs = new Set(available.map(variant => String(variant.id)));
          const selectedID = form.querySelector('[name="id"]')?.value;
          if (!fresh.available || !availableIDs.size || (!form.querySelector('[data-ps-accessory-variant]') && !availableIDs.has(selectedID))) {
            const focused = card.contains(document.activeElement);
            card.hidden = true;
            form.dataset.psAvailable = 'false';
            const cards = [...section.querySelectorAll('[data-ps-accessory]')].filter(item => !item.hidden);
            if (!cards.length) {
              section.querySelector('.ps-accessories__shelf').hidden = true;
              if (!section.querySelector('.ps-accessories__explore')) section.hidden = true;
            }
            if (focused) (cards[0]?.querySelector('a') || section.querySelector('.ps-accessories__path'))?.focus();
            return;
          }
          const select = form.querySelector('[data-ps-accessory-variant]');
          select?.querySelectorAll('option').forEach(option => {
            const variant = available.find(item => String(item.id) === option.value);
            if (!variant) option.remove();
            else { option.dataset.price = String(variant.price); option.textContent = `${variant.title} — ${formatter.format(Number(variant.price) / 100)}`; }
          });
          if (select && !availableIDs.has(selectedID)) {
            const prompt = document.createElement('option');
            prompt.value = '';
            prompt.disabled = true;
            prompt.selected = true;
            prompt.dataset.psAccessoryPrompt = '';
            prompt.textContent = text.chooseAvailable;
            select.prepend(prompt);
            select.value = '';
            form.dataset.psAvailable = 'false';
            const button = form.querySelector('[type="submit"]');
            if (button) button.disabled = true;
            const status = form.querySelector('[data-ps-form-status]');
            if (status) status.textContent = text.variantChanged;
          }
        } catch {} finally { delete card.dataset.refreshingStock; }
      }, { signal: abort.signal });
      controllers.set(section, abort);
    });
  };
  window.PhoneShopAccessories = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const sections = [...(event.target.matches?.('[data-ps-accessories]') ? [event.target] : []), ...event.target.querySelectorAll('[data-ps-accessories]')];
    sections.forEach(section => { controllers.get(section)?.abort(); controllers.delete(section); });
  });
})();
